// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.footerSection}>
            <h3>À propos de nous</h3>
            <p>Dy'kass est votre destination en ligne pour des produits agricoles frais et de qualité, directement des fermes à votre table.</p>
          </div>
          <div className={styles.footerSection}>
            <h3>Liens rapides</h3>
            <ul className={styles.footerLinks}>
              <li><Link to="/">Accueil</Link></li>
              <li><a href="/#products-section">Produits</a></li>
              <li><a href="#">À propos</a></li>
              <li><a href="#">Contact</a></li>
              <li><Link to="/politique-confidentialite">Politique de confidentialité</Link></li>
            </ul>
          </div>
          <div className={styles.footerSection}>
            <h3>Catégories</h3>
            <ul className={styles.footerLinks}>
              <li><a href="#">Légumes</a></li>
              <li><a href="#">Fruits</a></li>
              <li><a href="#">Épicerie</a></li>
              <li><a href="#">Produits laitiers</a></li>
            </ul>
          </div>
          <div className={styles.footerSection}>
            <h3>Contact</h3>
            <ul className={styles.footerLinks}>
              <li><i className="fas fa-map-marker-alt"></i> Akanda, Libreville</li>
              <li><i className="fas fa-phone"></i> +241 06 78 07 73</li>
              <li><i className="fas fa-envelope"></i> bbndiade@gmail.com</li>
            </ul>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <p>&copy; 2025 Dy'kass. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;